export enum KmOrMiles {
  KM = 'km',
  MILES = 'miles'
}
